import Header from "../components/Common/Header";
import Faq from "../components/Common/Faq";
import Banner from "../components/Common/Banner";
import Footer from "../components/Common/Footer";
import Cover from "../components/Index/Cover";
import Experience from "../components/Index/Experience";
import GettingStarted from "../components/Index/GettingStarted";
import Testimonials from "../components/Index/Testimonials";
import faqData from '../config/faq.json';
import Reviews from '../components/Index/Reviews';

function Presentation() {

  let index  = Math.ceil(faqData["homeData"]['rows'].length/2);

  let rows = faqData["homeData"].rows;
  let data1 = {title:'',rows:[]};
  data1.rows = rows.slice(0,index);

  let data2 = {title:'',rows:[]};
  data2.rows = rows.slice(index,faqData["homeData"]['rows'].length);


  return (
    <div>
      <Header></Header>
      <div style={{ paddingTop: '80px', paddingLeft: '20px', paddingRight: '20px' }}>
        <div style={{ position: 'relative', width: '100%', height: 0, paddingTop: '56.2500%',
          paddingBottom: 0, boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)', marginTop: '1.6em', marginBottom: '0.9em', overflow: 'hidden',
          borderRadius: '8px', willChange: 'transform' }}>
          <iframe loading="lazy" style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, border: 'none', padding: 0, margin: 0 }}
            src="https://www.canva.com/design/DAGpg2BsDBM/P0_L66ZgeDeeqUXg8UgBXA/view?embed" allowFullScreen="allowfullscreen" allow="fullscreen">
          </iframe>
        </div>
        {/* <a href="https://www.canva.com/design/DAGpg2BsDBM/P0_L66ZgeDeeqUXg8UgBXA/view?utm_content=DAGpg2BsDBM&utm_campaign=designshare&utm_medium=embeds&utm_source=link" target="_blank" rel="noopener">Casava Credit Insurance Plus</a> by Casava */}
        {/* <Cover></Cover>
        <GettingStarted></GettingStarted>
        <Experience></Experience>
        <Testimonials></Testimonials>
        <Reviews />
        <Faq data1={data1} data2={data2}></Faq> */}
        <Banner></Banner>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default Presentation;
